export enum Beta {
  CmUseNodeApi = 'jarvis:beta:cm_use_node_api',
}

export const configurableBetas = [Beta.CmUseNodeApi];

export interface BetaInfo {
  title: string;
  image: string;
  description: string;
}

export const betaInfo: Partial<Record<Beta, BetaInfo>> = {
  [Beta.CmUseNodeApi]: {
    title: 'Config Manager Node API',
    image: './assets/beta/cm-use-fast-api.jpg',
    description:
      'This is a refactor of the core functionalities of Config Manager ' +
      'developed with Node.js, aims to be a more performant and ' +
      'maintainable project.',
  },
};
